import { IUserProfileTenant } from 'features/userProfileApps/UserProfileApps';

export enum AclEntriesPage {
    TenantUser = 'TenantUser',
    TenantUserGroup = 'TenantUserGroup',
    UserProfile = 'UserProfile',
    License = 'License'
}

export interface AclEntriesDrawerProperties {
    tenantId: string;
    tenantName: string;
    tenantRequiresLicense: boolean;
    principalId: string;
    principalName: string;
    aclPage: AclEntriesPage;
    licenseId?: string;
    licenseBillingSystemName?: string;
    licenseBillingRecord?: string;
    currentUserProfileTenant?: IUserProfileTenant;
}

export interface AclEntiriesDeleteDialogProperties {
    aclPage: AclEntriesPage;
    principalName?: string;
    principalId?: string;
    licenseBillingRecord?: string;
    currentUserProfileTenant?: IUserProfileTenant;
    tenantRequiresLicense?: boolean;
}

export interface AclInfo {
    resourceTableName: string;
    accessTableName: string;
    tenantId: string;
    licenseId?: string;
    accessId: string;
    resourceId: string;
    userId?: string;
    usergroupId?: string;
    principalName?: string;
    resourceName?: string;
    accessName?: string;
}
